<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <i class="fa fa-microchip"></i>
          </template>

          <template slot="content">
            <p class="category">CPU</p>
            <h3 class="title">
              {{ current_resource.cpu.percentage }}%
              <small>({{ current_resource.cpu.cores }} cores)</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats"></div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <i class="fa fa-memory"></i>
          </template>

          <template slot="content">
            <p class="category">Memory</p>
            <h3 class="title">
              {{
                (
                  current_resource.virtual_memory.used / Math.pow(1024, 3)
                ).toFixed(1)
              }}<small
                >/{{
                  (
                    current_resource.virtual_memory.total / Math.pow(1024, 3)
                  ).toFixed(1)
                }}
                GB
              </small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats"></div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 flt-stats-card stat-card"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <i class="fa fa-exchange-alt"></i>
          </template>

          <template slot="content">
            <p class="category">Swap</p>
            <h3 class="title">
              {{ (current_resource.swap.used / Math.pow(1024, 3)).toFixed(1)
              }}<small
                >/{{
                  (current_resource.swap.total / Math.pow(1024, 3)).toFixed(1)
                }}
                GB
              </small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats"></div>
          </template>
        </stats-card>
      </div>
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card flt-stats-card stat-card"
      >
        <stats-card data-background-color="red">
          <template slot="header">
            <i class="fa fa-hdd"></i>
          </template>

          <template slot="content">
            <p class="category">Disk</p>
            <h3 class="title">
              {{ (current_resource.disk.used / Math.pow(1024, 3)).toFixed(0)
              }}<small
                >/{{
                  (current_resource.disk.total / Math.pow(1024, 3)).toFixed(0)
                }}
                GB
              </small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats"></div>
          </template>
        </stats-card>
      </div>

      <!-- Charts -->
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="purple" class="md-layout">
            <div
              class="md-layout md-layout-item md-size-100 md-alignment-center-space-between"
            >
              <div>
                <h4 class="title">
                  CPU Status
                </h4>
                <p class="category">
                  In last <b>{{cpuSelectedTimeFrame | makeHumanReadable}}</b> every
                  <b>{{timeFrameMap[cpuSelectedTimeFrame][0] | makeHumanReadable}}</b>
                </p>
              </div>
              <div>
                <md-button
                    v-for="item in ['5min', '10min', '20min', '30min', '1hr', '2hr', '4hr', '24hr']"
                    v-bind:key="item"
                    :class="[item == cpuSelectedTimeFrame ? 'time-selected' : '', 'md-icon-button', 'md-dense', 'times-btn' ]"
                    @click="updateData(item, 'cpu')"
                    :disabled="item == cpuSelectedTimeFrame"
                >
                  {{item.match(/\d+/g)[0]}}<sub>{{item.replace(/\d+/g, "")[0]}}</sub>
                </md-button>
                <md-button
                    class="md-icon-button md-dense refresh-btn"
                    @click="updateData(cpuSelectedTimeFrame, 'cpu')"
                >
                  <md-tooltip md-direction="top"
                  >Refresh Chart
                  </md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div>

              <div id="chart-timeline">
                <apexchart
                  type="area"
                  height="450"
                  :options="cpuChart.chartOptions"
                  :series="cpuChart.series"
                  ref="cpuChart"
                ></apexchart>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="purple" class="md-layout">
            <div class="md-layout md-layout-item md-size-100 md-alignment-center-space-between">
              <div>
                <h4 class="title">
                  Memory Status
                </h4>
                <p class="category">
                  In last <b>{{memorySelectedTimeFrame | makeHumanReadable}}</b> every
                  <b>{{timeFrameMap[memorySelectedTimeFrame][0] | makeHumanReadable}}</b>
                </p>
              </div>
              <div>
                <md-button
                    v-for="item in ['5min', '10min', '20min', '30min', '1hr', '2hr', '4hr', '24hr']"
                    v-bind:key="item"
                    :class="[item == memorySelectedTimeFrame ? 'time-selected' : '', 'md-icon-button', 'md-dense', 'times-btn' ]"
                    @click="updateData(item, 'memory')"
                    :disabled="item == memorySelectedTimeFrame"
                >
                  {{item.match(/\d+/g)[0]}}<sub>{{item.replace(/\d+/g, "")[0]}}</sub>
                </md-button>
                <md-button
                    class="md-icon-button md-dense refresh-btn"
                    @click="updateData(memorySelectedTimeFrame, 'memory')"
                >
                  <md-tooltip md-direction="top"
                  >Refresh Chart
                  </md-tooltip>
                  <md-icon>refresh</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div>
              <div>
                <apexchart
                  type="area"
                  height="450"
                  :options="memoryChart.chartOptions"
                  :series="memoryChart.series"
                  ref="memoryChart"
                ></apexchart>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { StatsCard } from "@/components";

export default {
  components: {
    StatsCard
  },
  name: "ServerInfo",
  data() {
    return {
      timeSeries: [],
      selection: "all",
      timeFrameMap: {
        "5min": ["20s", 5 * 60],
        "10min": ["20s", 10 * 60],
        "20min": ["20s", 20 * 60],
        "30min": ["20s", 30 * 60],
        "1hr": ["20s", 60 * 60],
        "2hr": ["20s", 2 * 60 * 60],
        "4hr": ["40s", 4 * 60 * 60],
        "24hr": ["2min", 24 * 60 * 60]
      },
      cpuSelectedTimeFrame: "4hr",
      memorySelectedTimeFrame: "4hr",
      requestData: {
        offset: 0,
        sample_rate: "5min"
      },
      cpuChart: {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {

          chart: {
            type: "area",
            stacked: false,
            zoom:{
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0
          },
          title: {
            align: "left"
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.5,
              opacityTo: 0,
              stops: [0, 90, 100]
            }
          },
          yaxis: {
            min: 0,
            max: 100,
            title: {
              text: "Usage"
            },
            labels:{
              formatter: (value) => { return `${Math.floor(value)}%` },
            }
          },
          xaxis: {
            title: {
              text: "Time"
            },
            type: "datetime",
            labels: {
              formatter: function(val) {
                return new Date(val * 1000).toLocaleTimeString();
              }
            }
          }
        }
      },
      memoryChart: {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            stacked: false,
            zoom:{
              enabled: false
            },
          },
          dataLabels: {
            enabled: false
          },
          markers: {
            size: 0
          },
          title: {
            align: "left"
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.5,
              opacityTo: 0,
              stops: [0, 90, 100]
            }
          },
          yaxis: {
            min: 0,
            max: 100,
            title: {
              text: "Usage"
            },
            labels:{
              formatter: (value) => { return `${Math.floor(value)}%` },
            }
          },
          xaxis: {
            title: {
              text: "Time"
            },
            type: "datetime",
            labels: {
              formatter: function(val) {
                return new Date(val * 1000).toLocaleTimeString();
              }
            }
          }
        }
      },
      current_resource: {
        cpu: {
          percentage: 0,
          cores: 0
        },
        virtual_memory: {
          total: 0,
          percent: 0,
          used: 0,
          free: 0
        },
        swap: {
          total: 0,
          percent: 0,
          used: 0,
          free: 0
        },
        disk: {
          total: 0,
          used: 0,
          free: 0,
          percent: 0
        },
        network: {
          bytes_sent: 0,
          bytes_recv: 0,
          ip_addresses: []
        }
      }
    };
  },
  filters: {
    makeHumanReadable: function(value) {
      return value.replace("s", " seconds").replace("hr", " hours").replace("min", " minutes");
    }
  },
  methods: {
    getServerInfo: async function(chart = "all") {
      try {
        let url =
          this.$store.state.server_address + "api/v1/dashboard/server-info/";
        if (this.requestData.offset !== 0) {
          let params = new URLSearchParams();
          for (const property in this.requestData) {
            params.append(property, this.requestData[property]);
          }
          url = `${url}?${params.toString()}`;
        }
        let headers = {
          "Content-Type": "application/json",
          Authorization: this.$store.getters.getAccessToken
        };
        let response = await fetch(url, {
          method: "GET",
          headers: headers
        });
        let jsonResponse = await response.json();
        this.current_resource = jsonResponse.response.current_resource;
        if (chart === "all" || chart === "cpu") {
          this.cpuChart.series[0].data = jsonResponse.response.cpu_percent;
          this.$refs.cpuChart.refresh();
        }

        if (chart === "all" || chart === "memory") {
          this.memoryChart.series[0].data =
            jsonResponse.response.memory_percent;
          this.$refs.memoryChart.refresh();
        }
      } catch (error) {
        console.log(error);
      }
    },
    updateData: function(timeFrame, chart) {
      // console.log(chart, timeFrame, this.cpuSelectedTimeFrame);
      if(chart === "cpu") {
        this.cpuSelectedTimeFrame = timeFrame;
      } else if(chart === "memory") {
        this.memorySelectedTimeFrame = timeFrame;
      }
      this.requestData.offset =
        Math.floor(Date.now() / 1000) - this.timeFrameMap[timeFrame][1];
      this.requestData.sample_rate = this.timeFrameMap[timeFrame][0];
      this.getServerInfo(chart);
    }
  },
  created() {
    this.updateData("4hr");
  }
};
</script>

<style scoped lang="scss">
.stat-card {
  @media (max-width: 1400px) {
    min-width: 50% !important;
    max-width: 50% !important;
    flex: 0 1 50% !important;
  }
  @media (max-width: 540px) {
    min-width: 100% !important;
    max-width: 100% !important;
    flex: 0 1 100% !important;
  }
}

button{
  width: 100%;
  border: none;
  background-color: white;
}
button:hover{
  cursor: pointer;
  color: purple;
}

.times-btn,
.refresh-btn {
    color: white !important;
    background: none;
    text-transform: lowercase;
}

.refresh-btn i {
  color: white !important;
}

.time-selected.times-btn {
  border: solid 1px white;
}
</style>
